import $ from 'jquery'
import TTDetailReportEditConfigController from './TTDetailReportEditConfigController'
import {getInstance as tooltip} from '../../../SimpleSingletonTooltip'
import messageResource from '../../../messageResource'

export default class TTDetailReportEditResultConfigController extends TTDetailReportEditConfigController {}

TTDetailReportEditResultConfigController.prototype.init = function ( config ) {
    TTDetailReportEditConfigController.prototype.init.call(this, config);

    $("#joinCommentsInfoContainer").show();

    tooltip().subscribeToMouseEvents($("#joinCommentsInfo"), () => {
        tooltip().setState({
            text: messageResource.getMessage('reports.comments_report.form.format.joined_comments_note'),
            extraClass: 'joinCommentsTooltip'
        })
    })

    return this;
};

TTDetailReportEditResultConfigController.prototype.makeReportParamsAccordingToFeatures = function( reportParameters ){
    return reportParameters;
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ttDetail/TTDetailReportEditResultConfigController.js